/**
 * bundle-visibility.js
 * -----------------------------------------------------------------------------
 * Hides the bundle popup Info button when a product's trigger.visibility
 * metafield value is "Not Visible Individually". Shows it otherwise.
 *
 * RULE
 *   value === "Not Visible Individually"      -> HIDE button
 *   any other value                           -> SHOW button
 *   product null (not readable by storefront) -> HIDE button
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  const SHOP_DOMAIN      = 'klimaworld.myshopify.com';
  const STOREFRONT_TOKEN = '9bba8ec5a96f5ac81322723a79d1e3da';
  const API_VERSION      = '2025-07';

  const TRIGGER_SELECTOR = '.avis-cs-button.avis-bundle-option-product';
  const HIDE_SELECTOR    = '.avis-modal-bundle-handle-button';
  const HIDE_VALUE       = 'Not Visible Individually';
  const OBSERVE_TIMEOUT  = 10000;

  const cache = new Map();

  function getProduct(productId) {
    if (cache.has(productId)) return cache.get(productId);

    const promise = (async function () {
      const query = `
        query($id: ID!) {
          product(id: $id) {
            title
            metafield(namespace: "trigger", key: "visibility") { value }
          }
        }`;
      try {
        const res = await fetch(
          'https://' + SHOP_DOMAIN + '/api/' + API_VERSION + '/graphql.json',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
            },
            body: JSON.stringify({
              query,
              variables: { id: 'gid://shopify/Product/' + productId }
            })
          }
        );
        const json = await res.json();
        return json && json.data ? json.data.product : null;
      } catch (err) {
        console.warn('[bundle-visibility] lookup failed for', productId, err);
        return null;
      }
    })();

    cache.set(productId, promise);
    return promise;
  }

  function applyVisibility(shouldShow) {
    document.querySelectorAll(HIDE_SELECTOR).forEach(function (btn) {
      if (shouldShow) {
        btn.style.removeProperty('display');
      } else {
        btn.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function whenPopupButtonAppears(cb) {
    if (document.querySelector(HIDE_SELECTOR)) { cb(); return; }
    const observer = new MutationObserver(function () {
      if (document.querySelector(HIDE_SELECTOR)) {
        observer.disconnect();
        cb();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, OBSERVE_TIMEOUT);
  }

  if (window.__bundleVisibilityBound) return;
  window.__bundleVisibilityBound = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest(TRIGGER_SELECTOR);
    if (!btn) return;

    const label = btn.closest('label');
    const radio = label && label.querySelector('input[type="radio"]');
    if (!radio) { console.warn('[bundle-visibility] no radio in label'); return; }

    const productId = radio.getAttribute('data-variant-product');
    if (!productId) { console.warn('[bundle-visibility] no data-variant-product'); return; }

    const product = await getProduct(productId);
    const value   = product && product.metafield ? product.metafield.value : null;

    const shouldHide = (value === HIDE_VALUE) || !product;

    whenPopupButtonAppears(function () { applyVisibility(!shouldHide); });
  }, true);
})();
